// pages/BeyondAcademics.js
import React from 'react';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';

const BeyondAcademics = () => {
  return (
    <div className="p-3 sm:p-5  min-h-screen">
      <h1 className="text-2xl sm:text-3xl font-bold text-center mb-6 text-primary">
        Beyond Academics
      </h1>

      <p className="text-center text-base sm:text-lg mb-3">
        At our school, learning goes beyond books. We offer a rich blend of
        extracurricular and co-curricular activities that nurture creativity,
        leadership, and teamwork.
      </p>

      <p className="text-center text-base sm:text-lg mb-6">
        Students are encouraged to explore their interests, develop talents,
        and build confidence while creating a well-rounded educational
        experience.
      </p>

      <div className="flex flex-wrap gap-0">
        {/* House System */}
        <div className="col-12 md:col-6">
          <Card title="House System" className="p-3 border-round-xl shadow-3">
            <img
              src="/images/dis (4).jpg"
              alt="House System"
              className="w-full border-round mb-3"
            />
            <p>
              Our school follows a structured House System that divides students
              into different houses for competitions and activities. This fosters
              teamwork, leadership, and a sense of belonging.
            </p>
            <p>
              Inter-house events in sports, arts, and academics encourage healthy
              competition and help students develop confidence, discipline, and
              camaraderie.
            </p>
          </Card>
        </div>

        {/* Cultural Activities */}
        <div className="col-12 md:col-6">
          <Card title="Cultural Activities" className="p-3 border-round-xl shadow-3">
            <img
              src="/images/dis (5).jpg"
              alt="Cultural Activities"
              className="w-full border-round mb-3"
            />
            <p>
              Our school organizes regular cultural programs to celebrate arts,
              music, dance, and drama. These activities help students discover
              their talents and express themselves creatively.
            </p>
            <p>
              Students participate in competitions, exhibitions, and events that
              build confidence, teamwork, and cultural appreciation beyond
              academics.
            </p>
          </Card>
        </div>

        {/* Sports */}
        <div className="col-12 md:col-6">
          <Card title="Sports" className="p-3 border-round-xl shadow-3">
            <img
              src="/images/dis (6).jpg"
              alt="Sports"
              className="w-full border-round mb-3"
            />
            <p>
              Our sports programs include both indoor and outdoor activities such
              as football, basketball, badminton, and yoga. Physical education
              ensures a healthy mind and body.
            </p>
            <p>
              Regular tournaments, matches, and fitness sessions teach students
              discipline, teamwork, and resilience, helping them succeed in life
              both on and off the field.
            </p>
          </Card>
        </div>

        {/* Clubs */}
        <div className="col-12 md:col-6">
          <Card title="Clubs" className="p-3 border-round-xl shadow-3">
            <img
              src="/images/dis (9).jpg"
              alt="Clubs"
              className="w-full border-round mb-3"
            />
            <p>
              Students can join various clubs like Science, Debate, Robotics,
              Eco, and Literature to explore their interests and passions beyond
              academics.
            </p>
            <p>
              Clubs conduct workshops, activities, and competitions that foster
              creativity, leadership, and critical thinking skills, enriching
              students’ overall development.
            </p>
          </Card>
        </div>
      </div>

      <Divider />

      <p className="text-center text-base sm:text-lg mt-5">
        Beyond academics, our school provides a nurturing environment that
        encourages students to explore, grow, and excel in every area of life.
      </p>
      <p className="text-center text-base sm:text-lg">
        By participating in houses, cultural programs, sports, and clubs,
        students gain valuable life skills, confidence, and a sense of
        accomplishment.
      </p>
    </div>
  );
};

export default BeyondAcademics;
